import React, { useState } from "react";
import { isNull } from "lodash";
import Modal from "react-modal";
import { BUILDINGS } from "./heatmapConfig";
import BuildingLinechart from "../../components/graphs/BuildingLinechart.jsx";
import "./map.css";

interface BuildingPopupProps {
  selectedBuildingId: string | null;
  closePopup: () => void;
}

export const BuildingPopup: React.FC<BuildingPopupProps> = ({
  selectedBuildingId,
  closePopup,
}) => {
  const building = BUILDINGS[selectedBuildingId ?? ""] ?? {};

  const [showInfo, setShowInfo] = useState<boolean>(true); // State to track info section visibility
  //const SelectedGraphComponent = selectedBuildingId
  //? graphComponents[selectedBuildingId]
  //: null;

  return (
    <Modal
      isOpen={!isNull(selectedBuildingId)}
      onRequestClose={closePopup}
      style={{
        overlay: {
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(0, 0, 0, 0.25)",
          overflow: "hidden",
        },
        content: {
          border: "1px solid #ccc",
          borderRadius: "16px",
          padding: "30px 60px",
          overflow: "hidden",
          width: "85%",
          height: "85%",
          margin: "auto",
          boxSizing: "border-box",
        },
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          flexGrow: 1,
        }}
      >
        {/* Buttons */}
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "flex-start",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            <h2
              style={{ fontSize: "36px", margin: 0 }}
              className="font-ruzicka"
            >
              {building.name}
            </h2>
            <p
              style={{
                fontSize: "20px",
                marginTop: 0,
                marginBottom: 15,
              }}
              className="font-ruzicka"
            >
              Constructed {building.constructedIn}
            </p>
          </div>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              borderRadius: "8px",
              border: "2px solid #E5E5E5",
              flexShrink: 0,
              padding: 3,
            }}
          >
            <button
              onClick={() => {
                setShowInfo(true);
              }}
              className={`popupTab ${
                showInfo ? "selectedPopupTab" : "unselectedPopupTab"
              }`}
            >
              Info
            </button>
            <button
              onClick={() => {
                setShowInfo(false);
              }}
              className={`popupTab ${
                showInfo ? "unselectedPopupTab" : "selectedPopupTab"
              }`}
            >
              Graph
            </button>
          </div>
        </div>

        {/* Image */}
        {showInfo ? (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              gap: 50,
            }}
          >
            <div
              style={{
                flexShrink: 0,
                width: "35%",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <img
                src={"../" + building.img}
                alt="Building"
                style={{
                  width: "100%",
                }}
              />
              <h4 style={{ marginBottom: 0, marginTop: 18 }}>Did you know?</h4>
              <p className="popupP" style={{ marginTop: 5 }}>
                {building.factoid}
              </p>
            </div>

            {/* Title and Description */}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                overflow: "scroll",
                height: "100%",
              }}
            >
              <h4 style={{ margin: 0 }}>About</h4>
              <p className="popupP">{building.description}</p>

              {building.energyResearch && (
                <>
                  <h4 style={{ margin: "10px 0 0 0" }}>
                    Energy Research and Labs
                  </h4>
                  <p className="popupP">{building.energyResearch}</p>
                </>
              )}
            </div>
          </div>
        ) : (
          <div
            style={{
              flex: 1,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
              height: "100%",
            }}
          >
            <BuildingLinechart
              buildingName={building.dbName}
              upperDomain={
                building.lineChartUpper ? building.lineChartUpper : 600000
              }
            />
          </div>
        )}
      </div>

      <button
        onClick={() => {
          setShowInfo(true);
          closePopup();
        }}
        style={{
          padding: "10px 20px",
          boxSizing: "border-box",
          border: "2px solid #003c73",
          borderRadius: 10,
          position: "absolute",
          right: "5%",
          bottom: "5%",
          fontWeight: 600,
          color: "#003c73",
          fontSize: "16px",
        }}
      >
        Close
      </button>
    </Modal>
  );
};
